import { api } from '../utils/api';

export interface AuditLog {
  id: number;
  userId: number | null;
  userName: string | null;
  action: string;
  entityType: string | null;
  entityId: string | null;
  description: string | null;
  metadata: any | null;
  ip: string | null;
  createdAt: string;
}

export interface AuditLogsParams {
  action?: string;
  user_id?: string | number;
  from?: string;
  to?: string;
  limit?: number;
}

export async function getAuditLogs(params: AuditLogsParams = {}): Promise<AuditLog[]> {
  const { data } = await api.get<AuditLog[]>('/audit-logs', { params });
  return data;
}
